import createActions from "helpers/actionCreator"

export const { Types, Creators } = createActions("ompnt/modules/profile-modal", {
  openFactorProfile: ["id"],
  closeFactorProfile: [],
  openSecurityProfile: (mic, ticker) => {
    if (ticker) {
      return { ticker, mic }
    } else {
      const parts = mic.split(".")
      mic = parts.shift()
      return { ticker: parts.join("."), mic }
    }
  },
  openSecurityProfile2: ["assetClass", "id", "ticker", "mic"],
  closeSecurityProfile: [],
})
